import React, { useRef, useState } from 'react';
import emailjs from '@emailjs/browser';
import { Send, CheckCircle, AlertCircle } from 'lucide-react';

export default function ContactForm() {
    const form = useRef();
    const [status, setStatus] = useState('idle'); // idle, sending, success, error
    const [errorMessage, setErrorMessage] = useState('');

    const sendEmail = (e) => {
        e.preventDefault();
        setStatus('sending');

        // Note: These should be replaced with actual IDs from EmailJS or process.env
        const serviceId = process.env.REACT_APP_EMAILJS_SERVICE_ID || 'YOUR_SERVICE_ID';
        const templateId = process.env.REACT_APP_EMAILJS_TEMPLATE_ID || 'YOUR_TEMPLATE_ID';
        const publicKey = process.env.REACT_APP_EMAILJS_PUBLIC_KEY || 'YOUR_PUBLIC_KEY';

        emailjs.sendForm(serviceId, templateId, form.current, publicKey)
            .then((result) => {
                console.log(result.text);
                setStatus('success');
                form.current.reset();
            }, (error) => {
                console.log(error.text);
                setStatus('error');
                setErrorMessage('Ocorreu um erro ao enviar sua mensagem. Por favor, tente novamente mais tarde.');
            });
    };

    return (
        <section id="contact" className="py-20 px-4 bg-white">
            <div className="max-w-4xl mx-auto">
                <div className="text-center mb-12">
                    <h2 className="text-3xl md:text-4xl font-bold mb-4 text-black">
                        Entre em <span className="text-cyan-400">Contato</span>
                    </h2>
                    <p className="text-gray-600 max-w-2xl mx-auto">
                        Tem alguma dúvida ou quer iniciar um projeto? Preencha o formulário abaixo e entraremos em contato o mais breve possível.
                    </p>
                </div>

                <div className="bg-gray-50 rounded-2xl shadow-xl overflow-hidden border border-gray-100">
                    <div className="p-8 md:p-12">
                        <form ref={form} onSubmit={sendEmail} className="space-y-6">
                            <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                                <div>
                                    <label htmlFor="user_name" className="block text-sm font-semibold text-gray-700 mb-2">
                                        Nome Completo
                                    </label>
                                    <input
                                        type="text"
                                        name="user_name"
                                        id="user_name"
                                        required
                                        className="w-full px-4 py-3 rounded-lg bg-white border border-gray-300 focus:border-cyan-400 focus:ring-2 focus:ring-cyan-100 outline-none transition"
                                        placeholder="Seu nome"
                                    />
                                </div>
                                <div>
                                    <label htmlFor="user_email" className="block text-sm font-semibold text-gray-700 mb-2">
                                        Email
                                    </label>
                                    <input
                                        type="email"
                                        name="user_email"
                                        id="user_email"
                                        required
                                        className="w-full px-4 py-3 rounded-lg bg-white border border-gray-300 focus:border-cyan-400 focus:ring-2 focus:ring-cyan-100 outline-none transition"
                                        placeholder="seu@email.com"
                                    />
                                </div>
                            </div>

                            <div>
                                <label htmlFor="message" className="block text-sm font-semibold text-gray-700 mb-2">
                                    Mensagem
                                </label>
                                <textarea
                                    name="message"
                                    id="message"
                                    rows="5"
                                    required
                                    className="w-full px-4 py-3 rounded-lg bg-white border border-gray-300 focus:border-cyan-400 focus:ring-2 focus:ring-cyan-100 outline-none transition resize-none"
                                    placeholder="Como podemos ajudar?"
                                ></textarea>
                            </div>

                            <div className="flex flex-col items-center">
                                <button
                                    type="submit"
                                    disabled={status === 'sending'}
                                    className={`w-full md:w-auto px-8 py-4 rounded-full font-bold text-white flex items-center justify-center gap-2 transition transform hover:scale-105 active:scale-95 ${
                                        status === 'sending' ? 'bg-gray-400 cursor-not-allowed' : 'bg-cyan-400 hover:bg-cyan-500 shadow-lg shadow-cyan-200'
                                    }`}
                                >
                                    {status === 'sending' ? 'Enviando...' : (
                                        <>
                                            Enviar Mensagem
                                            <Send size={18} />
                                        </>
                                    )}
                                </button>

                                {status === 'success' && (
                                    <div className="mt-6 flex items-center gap-2 text-green-600 font-medium animate-fade-in">
                                        <CheckCircle size={20} />
                                        <span>Mensagem enviada com sucesso!</span>
                                    </div>
                                )}

                                {status === 'error' && (
                                    <div className="mt-6 flex items-center gap-2 text-red-600 font-medium animate-fade-in">
                                        <AlertCircle size={20} />
                                        <span>{errorMessage}</span>
                                    </div>
                                )}
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </section>
    );
}
